export default __webpack_public_path__ + "static/media/fi-br-settings.e3ae818c.svg";